import { render, staticRenderFns } from "./ImprimantesHpLatex.vue?vue&type=template&id=45d6857b&scoped=true"
import script from "./ImprimantesHpLatex.vue?vue&type=script&lang=js"
export * from "./ImprimantesHpLatex.vue?vue&type=script&lang=js"
import style0 from "./ImprimantesHpLatex.vue?vue&type=style&index=0&id=45d6857b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6857b",
  null
  
)

export default component.exports